
export const generateUniqueID = () => {
    const timestamp = new Date().getTime();
    return `${timestamp}`;
  }
  